<template>
  <div class="mobile_change_making">
    <div class="mySwitch">
      <!-- 显示当前选中项的图片 -->
      <img
        v-if="currentItem"
        style="width: 315px; height: 192px; margin: 20px 0"
        :src="currentItem.url"
        alt=""
      />
      <!-- 显示当前选中项的文字信息 -->
      <div class="slider-container">
        <!-- 左箭头 -->
        <div
          class="arrow left"
          @click="moveLeft"
          :style="{
            opacity: currentIndex === 0 ? 0.3 : 1,
            display: currentIndex === 0 ? 'none' : 'block',
          }"
        >
          <i class="el-icon-arrow-left"></i>
        </div>
        <!-- 外部容器，固定宽度并溢出隐藏 -->
        <div class="outer-box production_switch_scroll" ref="outerBox">
          <!-- 内部容器，根据数据渲染 -->
          <div
            class="inner-box"
            ref="innerBox"
            :style="{ transform: `translateX(-${offset}px)` }"
          >
            <div
              v-for="item in navItems"
              :key="item.id"
              class="item"
              :class="{ active: currentItem && item.id === currentItem.id }"
              @click="selectItem(item)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
        <!-- 右箭头 -->
        <div
          class="arrow right"
          @click="moveRight"
          :style="{
            opacity: canScrollRight() ? 1 : 0.3,
            display: canScrollRight() ? 'block' : 'none',
          }"
        >
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="SwitchText" v-if="currentItem">{{ currentItem.msg }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navItems: [
        {
          id: "001",
          title: "镜头测量与定位流程",
          msg: "5分钟自动计算完成测量得到的镜头数据文件，将三维世界的虚拟摄影机与现场真实摄影机坐标完全对齐无偏差",
          url: 'https://download.hecoos.com/enlightv/2025-17/37f549101ac217def309cf249ff30e36.png',
        },
        {
          id: "002",
          title: "延迟校准",
          msg: "测量摄影机延迟、媒体延迟，以及手动调整跟踪延迟，可以让屏幕画面和扩展画面完全同步，不出现卡顿和撕裂等画面瑕疵。",
          url: 'https://download.hecoos.com/enlightv/2025-17/bfadae3a04c9937fddfdbedf990bc4c8.png',
        },
        {
          id: "003",
          title: "色彩校正",
          msg: "通过比较摄影机拍摄LED屏幕和原始输入的色彩，自动计算校色文件，实现屏内画面与扩展画面颜色的准确统一。",
          url: 'https://download.hecoos.com/enlightv/2025-17/7e6c8a04ff7f81a12ff5bca98b38bbb2.png',
        },
        {
          id: "004",
          title: "多机位切换",
          msg: "当追踪系统数量与摄影机一对一匹配时，导播可根据需要在各追踪机位间无缝、适时切换拍摄画面，以表达丰富多样的视觉语言。",
          url: 'https://download.hecoos.com/enlightv/2025-17/ccac8c851186e55acae1dc6ac1d105f7.png',
        },
        {
          id: "005",
          title: "引擎关卡/序列管理",
          msg: "将Server-C服务器的时间线上添加的多个虚拟场景节目与虚幻引擎中的各个场景关卡一一对应，实现随时播控/触发虚拟场景中的序列动画。",
          url: 'https://download.hecoos.com/enlightv/2025-17/0745ae1a1b1f35b6837ac66f576e07d0.png',
        },
        {
          id: "006",
          title: "虚拟与现实灯光联调控制",
          msg: "以虚拟场景的灯光配置方案来构建真实影棚的灯光布局，hecoos通过ART-NET协议实现真实灯具的直接控制，达到虚拟与现实灯光同步联动。",
          url: 'https://download.hecoos.com/enlightv/2025-17/37f549101ac217def309cf249ff30e36.png',
        },
        {
          id: "007",
          title: "Rivermax集群渲染",
          msg: "内视锥渲染画面与集群中的其他渲染节点共享，避免各节点的渲染资源浪费，多节点合理分工使画面质量更高、更流畅。使用SMPTE 2110 同步策略对每个渲染节点进行帧锁定，确保虚幻引擎输出与摄影机保持同步。",
          url: 'https://download.hecoos.com/enlightv/2025-17/bfadae3a04c9937fddfdbedf990bc4c8.png',
        },
      ],
      currentIndex: 0,
      offset: 0,
      visibleItems: 0,
      currentItem: null,
      totalWidth: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.innerBox && this.$refs.outerBox) {
        this.currentItem = this.navItems[0];
        this.calculateVisibleItems();
        this.calculateTotalWidth();
      }
    });
  },
  methods: {
    moveLeft() {
      if (this.currentIndex > 0) {
        const prevItem = this.$refs.innerBox.children[this.currentIndex - 1];
        const moveWidth = prevItem.offsetWidth + 20;
        this.offset = Math.max(0, this.offset - moveWidth);
        this.currentIndex--;
      }
    },
    moveRight() {
      if (this.canScrollRight()) {
        const currentItem = this.$refs.innerBox.children[this.currentIndex];
        const moveWidth = currentItem.offsetWidth + 20;
        this.offset += moveWidth;
        this.currentIndex++;
      }
    },
    selectItem(item) {
      this.currentItem = item;
    },
    calculateVisibleItems() {
      if (this.$refs.innerBox && this.$refs.outerBox) {
        const outerBoxWidth = this.$refs.outerBox.offsetWidth;
        let totalWidth = 0;
        let visibleCount = 0;
        const items = this.$refs.innerBox.children;
        for (let i = 0; i < items.length; i++) {
          totalWidth += items[i].offsetWidth;
          if (i > 0) {
            totalWidth += 20;
          }
          if (totalWidth <= outerBoxWidth) {
            visibleCount++;
          } else {
            break;
          }
        }
        this.visibleItems = visibleCount;
      }
    },
    calculateTotalWidth() {
      if (this.$refs.innerBox) {
        let total = 0;
        const items = this.$refs.innerBox.children;
        for (let i = 0; i < items.length; i++) {
          total += items[i].offsetWidth;
          if (i > 0) {
            total += 20;
          }
        }
        this.totalWidth = total;
      }
    },
    getVisibleWidth() {
      return this.$refs.outerBox ? this.$refs.outerBox.offsetWidth : 0;
    },
    canScrollRight() {
      if (!this.$refs.innerBox) return false;
      const outerBoxWidth = this.getVisibleWidth();
      const lastItem =
        this.$refs.innerBox.children[this.$refs.innerBox.children.length - 1];
      const lastItemRight = this.totalWidth - lastItem.offsetWidth - 20;
      return (
        this.offset + outerBoxWidth < lastItemRight + lastItem.offsetWidth + 20
      );
    },
  },
  watch: {
    "$el.clientWidth": {
      handler() {
        this.calculateVisibleItems();
        this.calculateTotalWidth();
      },
      immediate: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mobile_xty.scss";
</style>
